import { BankingCard } from './types'

export const isInactive = (card: BankingCard): boolean => {
  return card.status === 'inactive'
}
